import * as React from 'react';
import Button from '@telia-front/button';
export default class ProgressBar extends React.Component {
    BEM() {
        const classArray = ['progress-bar'];
        if (this.props.progress >= 75) {
            classArray.push('progress-bar--fill-high');
        }
        else if (this.props.progress >= 50) {
            classArray.push('progress-bar--fill-medium');
        }
        else {
            classArray.push('progress-bar--fill-low');
        }
        if (this.props.type) {
            classArray.push('progress-bar--type-order');
        }
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        return classArray.join(' ');
    }
    getOverlayStyle() {
        return {
            width: `${this.props.progress}%`,
        };
    }
    getTitle() {
        return React.createElement("div", { className: "progress-bar__title" }, this.props.title);
    }
    getButton(button) {
        return React.createElement(Button, Object.assign({}, button, { size: "small", className: "progress-bar__button" }));
    }
    render() {
        return (React.createElement("div", { className: this.BEM() },
            this.props.title && this.getTitle(),
            React.createElement("div", { className: "progress-bar__inner" },
                React.createElement("div", { className: "progress-bar__bar progress-bar__bar--content" }, this.props.text),
                React.createElement("div", { className: "progress-bar__bar progress-bar__bar--overlay", style: this.getOverlayStyle() }, this.props.text),
                this.props.button && this.getButton(this.props.button))));
    }
}
